import './bootstrap';

//app
require('./main/alpine');
require('./main/mousetrap');
